import type { Appearance } from "@stripe/stripe-js";

export const CHECKOUT_PAYMENT_MODAL_MAX_WIDTH = 560;

export const checkoutStripeAppearance: Appearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#3B6FE8",
    colorBackground: "#ffffff",
    colorText: "#111827",
    colorTextSecondary: "#6b7280",
    colorTextPlaceholder: "#9ca3af",
    colorDanger: "#dc2626",
    fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSizeBase: "15px",
    spacingUnit: "4px",
    borderRadius: "9px",
  },
  rules: {
    ".Tab": {
      border: "1.5px solid #d6dae1",
      borderRadius: "10px",
      padding: "14px 12px",
      boxShadow: "none",
    },
    ".Tab:hover": {
      borderColor: "#b9c0cc",
    },
    ".Tab--selected": {
      borderColor: "#3B6FE8",
      boxShadow: "none",
    },
    ".TabLabel": {
      fontSize: "13px",
      fontWeight: "500",
    },
    ".TabIcon": {
      fill: "#3B6FE8",
    },
    ".Input": {
      border: "1px solid #d6dae1",
      borderRadius: "9px",
      padding: "12px 14px",
      boxShadow: "none",
    },
    ".Input:focus": {
      borderColor: "#3B6FE8",
      boxShadow: "0 0 0 3px rgba(59,111,232,.12)",
    },
    ".Label": {
      fontSize: "13px",
      fontWeight: "500",
      color: "#111827",
      marginBottom: "6px",
    },
    ".Block": {
      backgroundColor: "#ffffff",
      border: "1px solid #e2e5ea",
      borderRadius: "11px",
      padding: "18px",
    },
    ".CheckboxInput": {
      borderColor: "#d6dae1",
    },
    ".CheckboxInput--checked": {
      backgroundColor: "#3B6FE8",
      borderColor: "#3B6FE8",
    },
  },
};
